// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".blink_me[data-v-f64ffda2] {\n  -webkit-animation: blinker-f64ffda2 0.7s linear infinite;\n          animation: blinker-f64ffda2 0.7s linear infinite;\n}\n@-webkit-keyframes blinker-f64ffda2 {\n50% {\n    opacity: 40%;\n}\n}\n@keyframes blinker-f64ffda2 {\n50% {\n    opacity: 40%;\n}\n}", ""]);
// Exports
module.exports = exports;
